import { useState, useEffect } from 'react'
import { useConfigurableBuilderWarningsMutation } from '../graphql/ConfigurableBuilderWarningsMutation'

interface IUseGetConfigurableBuilderWarningsArgs {
  displayUserFeedback: (message: string, level: 'error' | 'info') => void
  builderId: string | undefined
  outboundConfigId: string | undefined
}

export const useGetConfigurableBuilderWarnings = ({
  builderId,
  displayUserFeedback,
  outboundConfigId,
}: IUseGetConfigurableBuilderWarningsArgs) => {
  const [configurableBuilderWarnings, setConfigurableBuilderWarnings] = useState<string[]>()
  const [getConfigurableBuilderWarningsMutation] = useConfigurableBuilderWarningsMutation()

  const getBuilderWarnings = async (input: { builderId: string; outboundConfigId: string }) => {
    try {
      const response = await getConfigurableBuilderWarningsMutation({
        variables: {
          input: {
            ...input,
          },
        },
      })
      const errors = response.data?.getConfigurableBuilderWarnings?.errors || []
      if (errors.length === 0) {
        const builderWarnings = response.data?.getConfigurableBuilderWarnings?.warnings || []
        setConfigurableBuilderWarnings(builderWarnings)
      } else {
        displayUserFeedback(errors[0].message, 'error')
      }
    } catch (e) {
      displayUserFeedback(e.message, 'error')
    }
  }

  // When reloading builder and outbound config, want to reload the associated warnings
  useEffect(() => {
    if (builderId && outboundConfigId) {
      getBuilderWarnings({
        builderId,
        outboundConfigId,
      })
    }
  }, [builderId, outboundConfigId])

  return {
    configurableBuilderWarnings,
  }
}
